import { Chip } from '@bp/ui-components';
import classNames from 'classnames';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { severityToken } from '../../../utils/timetable/severity';
import styles from './ReadinessSummary.module.scss';

type ReadinessSummaryProps = {
  blockers: number;
  warnings: number;
  hints: number;
  className?: string | undefined;
};

/** "N Blocker · M Warnungen · K Hinweise — startklar/nicht startklar" — shared across the findings surfaces. */
export const ReadinessSummary: FC<ReadinessSummaryProps> = ({ blockers, warnings, hints, className }) => {
  const { t } = useTranslation();
  const ready = blockers === 0;

  // Light, system-derived tint behind the severity-coloured label — no hand-mixed colour values.
  const tint = (color: string) => `color-mix(in srgb, ${color} 14%, var(--color-white))`;

  return (
    <div className={classNames(styles.readiness, className)}>
      <div className={styles.counts}>
        <Chip
          value={t('findings.blockers', { count: blockers })}
          color={severityToken('error').color}
          bgColor={tint(severityToken('error').color)}
        />
        <Chip
          value={t('findings.warnings', { count: warnings })}
          color={severityToken('warning').color}
          bgColor={tint(severityToken('warning').color)}
        />
        <Chip
          value={t('findings.hints', { count: hints })}
          color={severityToken('info').color}
          bgColor={tint(severityToken('info').color)}
        />
      </div>
      <Chip
        value={ready ? t('findings.ready') : t('findings.notReady')}
        color='var(--color-white)'
        bgColor={ready ? 'var(--color-success)' : 'var(--color-error)'}
      />
    </div>
  );
};
